module.exports = __webpack_public_path__ + "static/media/influence.ce4d393c.png";